import { render, staticRenderFns } from "./BlogService.vue?vue&type=template&id=09173b20&"
import script from "./BlogService.vue?vue&type=script&lang=js&"
export * from "./BlogService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports